import {Selectors, PluginNames} from '../Settings';
import AjaxUtility from '../../../../../ig_template/Resources/Public/Javascript/Utility/AjaxUtility';

export default class TrialTrainingForm {
    constructor($form) {
        this.$form = $form;
        this.$content = $(Selectors.trialTrainingFormContent);

        this.bindHandlers();
    }

    bindHandlers() {
        this.$form.on('submit', (e) => {
            e.preventDefault();

            let employee = this.$form.find('input#employeeUid').val();

            let inputValues = {
                firstName: this.$form.find('input#formFirstName').val(),
                lastName: this.$form.find('input#formLastName').val(),
                phone: this.$form.find('input#formPhone').val(),
                email: this.$form.find('input#formEmail').val()
            };

            AjaxUtility.request(3600, {
                controller: 'Employee',
                action: 'sendMail',
                employee: employee,
                form: inputValues
            }, PluginNames
            ).done(response => {
                let $contents = $(response).contents();

                this.hideFormContent();

                setTimeout(() => {
                    this.loadFormContent($contents);
                    this.showFormContent();
                }, 500);
            });
        });
    }

    loadFormContent($content) {
        this.$content.html($content);
    }

    hideFormContent() {
        this.$content.addClass('hideFormContent');
    }

    showFormContent() {
        this.$content.removeClass('hideFormContent');
    }
}